export default __webpack_public_path__ + "static/media/product-image-hover-1.a655f78f.jpg";